import { ACCESS_TOKEN } from "./keys";

export const setAccessToken = (token: string) => localStorage.setItem(ACCESS_TOKEN, token);
